import { ReferralModel } from '../../../entities/referral/model/types'

export const referralsData: ReferralModel[] = [
  {
    id: '123456',
    username: 'Payments_team1',
    status: 'active',
    dailyLimit: 567543,
    totalRequisitMaxDailyLimit: 1000000,
    totalTurnover: {
      amountTo: 2783.79,
      amountFrom: 280117,
    },
    personalProfit: 2783.79,
    conversion: {
      percentage: 76,
      current: 2526,
      goal: 3512,
    },
    refPercentage: 0.2,
  },
  {
    id: '123457',
    username: 'Payments_team2',
    status: 'paused',
    dailyLimit: 0,
    totalRequisitMaxDailyLimit: 0,
    totalTurnover: {
      amountTo: 2783.79,
      amountFrom: 280117,
    },
    personalProfit: 2783.79,
    conversion: {
      percentage: 0,
      current: 0,
      goal: 0,
    },
    refPercentage: 0.2,
  },
]

export const teamleadsData: ReferralModel[] = [
  {
    id: '222222',
    username: 'Payments_team3',
    status: 'unconnect',
    dailyLimit: 567543,
    totalRequisitMaxDailyLimit: 1000000,
    totalTurnover: {
      amountTo: 2783.79,
      amountFrom: 280117,
    },
    personalProfit: 2783.79,
    conversion: {
      percentage: 76,
      current: 2526,
      goal: 3512,
    },
    refPercentage: 1,
  },
  {
    id: '123457',
    username: 'Payments_team4',
    status: 'blocked',
    dailyLimit: 0,
    totalRequisitMaxDailyLimit: 0,
    totalTurnover: {
      amountTo: 2783.79,
      amountFrom: 280117,
    },
    personalProfit: 2783.79,
    conversion: {
      percentage: 0,
      current: 0,
      goal: 0,
    },
    refPercentage: 1,
  },
  {
    id: '123458',
    username: 'Deleted_user',
    status: 'deleted',
    dailyLimit: 0,
    totalRequisitMaxDailyLimit: 0,
    totalTurnover: {
      amountTo: 0,
      amountFrom: 0,
    },
    personalProfit: 0,
    conversion: {
      percentage: 0,
      current: 0,
      goal: 0,
    },
    refPercentage: 0,
  },
]
